<template>
  <div class="wrapper mx-auto" id="home-body">
    <section id="intro">
      <div id="intro-top" class="wrapper grid">
        <div
          class="intro-left aos-area"
          data-aos="fade-up"
          data-aos-delay="50"
          data-aos-duration="1250"
        >
          <h1>
            Sejarah Pendidikan Indonesia <span class="home-strip">-</span> SMK
            masa Kini dan yang akan datang
          </h1>
          <p>
            Mau tau tentang Sejarah Pendidikan yang ada di indonesia dan smk
            yang akan datang? yuk lihat selengkapnya.
          </p>
          <a href="#content" class="intro-cta"> Lihat Selengkapnya </a>
        </div>
        <div class="intro-right aos-area">
          <!-- Insert Image here -->
          <img
            data-aos="fade-left"
            data-aos-delay="50"
            data-aos-duration="1000"
            src="../assets/images/undraw_studying_s3l7.svg"
            alt="image"
            class="intro-right-img"
          />
        </div>
      </div>
    </section>
    <main id="content" class="">
      <section class="section-1">
        <div class="text-center aos-area">
          <h1
            class="heading relative z-20"
            data-aos="zoom-out-up"
            data-aos-delay="50"
            data-aos-duration="1000"
          >
            PENDIDIKAN
          </h1>
          <br /><br />
          <img
            data-aos="fade-up"
            data-aos-delay="50"
            data-aos-duration="1000"
            src="../assets/images/undraw_book_lover_mkck.svg"
            class="pendidikan-img mx-auto mb-4 relative z-20"
            alt="image"
          />

          <p
            class="desksejarah relative z-20"
            data-aos="fade-up"
            data-aos-delay="50"
            data-aos-duration="1000"
          >
            Apa yang dimaksud dengan pendidikan? Secara umum, pengertian
            pendidikan adalah suatu proses pembelajaran pengetahuan,
            keterampilan, dan kebiasaan sekumpulan manusia yang diwariskan dari
            satu genereasi ke generasi selanjutnya melalui pengajaran,
            pelatihan, dan penelitian. Ada juga yang mengatakan definisi
            pendidikan adalah suatu usaha sadar yang dilakukan secara sistematis
            dalam mewujudkan suasana belajar-mengajar agar para peserta didik
            dapat mengembangkan potensi dirinya. Dengan adanya pendidikan maka
            seseorang dapat memiliki kecerdasan, akhlak mulia, kepribadian,
            kekuatan spiritual, dan keterampilan yang bermanfaat bagi diri
            sendiri dan masyarakat. Ngomongin tentang Kata Pendidikan Indonesia,
            Pendidikan Indonesia Mempunyai banyak sejarah Dan juga Mempunyai
            beberapa tingkatan dalam Sekolah untuk melanjutkan Karir di Masa
            Depan yang harus kalian tau.
            <br /><br />
            Berikut adalah Dua Article singkat Tentang Sejarah Pendidikan
            Indonesia Dan Smk masa Kini Serta yang akan datang.
          </p>

          <div class="row grid grid-cols-1 md:grid-cols-2 mt-12">
            <div class="col-md-6 col-pr-12">
              <div class="gambar aos-area">
                <img
                  data-aos="fade-right"
                  data-aos-delay="50"
                  data-aos-duration="1000"
                  src="../assets/images/undraw_Notebook_re_id0r.svg"
                  alt="image"
                  class=""
                />
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div
                class="panel1 text-left"
                data-aos="fade-up"
                data-aos-delay="50"
                data-aos-duration="1250"
              >
                <h1>Sejarah Pendidikan Indonesia</h1>
                <p class="pt-4">
                  Indonesia menjadi salah satu negara kepulauan terbesar di
                  dunia. Indonesia memiliki lebih dari 17.000 pulau dan hanya
                  sekitar 7.000 pulau yang berpenghuni. Secara astronomi, letak
                  Indonesia diapit oleh dua benua yaitu Benua Asia dan Australia
                  serta dua samudra yaitu Samudra Hindia dan Pasifik.
                </p>
                <br />
                <p>
                  Indonesia terkenal dengan sumber daya alam (SDA) yang melimpah
                  ruah di setiap wilayahnya. Oleh sebab itu, pada zaman dahulu
                  Indonesia diincar oleh banyak bangsa barat hanya untuk
                  menguasai hasil rempah dan memperbudak mereka, beberapa di
                  antaranya yaitu Portugis, Belanda, Inggris, Jepang.
                </p>
                <router-link to="/sejarah" class="intro-cta">
                  Baca Selengkapnya
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-2">
        <div class="mx-auto text-center">
          <div
            class="row grid grid-cols-1 md:grid-cols-2 place-items-center mt-12"
          >
            <div class="col-md-6 col-12">
              <div
                class="panel2 text-left"
                data-aos="fade-up"
                data-aos-delay="50"
                data-aos-duration="1250"
              >
                <h1>Smk Masa Kini Dan Yang Akan Datang</h1>
                <p class="pt-4">
                  Pendidikan di Indonesia berawal dari pendidikan berbasis
                  keagamaan yang di selenggarakan oleh para pemuka dan penyebar
                  agama Hindu, Budha, dan Islam. Pada zamannya, mereka telah
                  mengembangkan sistem pendidikan yang relatif terstruktur dari
                  segi isi maupun tingkatannya.
                </p>
                <br />
                <p>
                  Namun sistem pendidikan dalam bentuk sekolah atau menyerupai
                  sekolah baru dimulai pada abad ke-16...
                </p>
                <router-link
                  to="/article/smk-masa-kini-dan-yang-akan-datang"
                  class="intro-cta"
                >
                  Baca Selengkapnya
                </router-link>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div
                class="gambar"
                data-aos="fade-left"
                data-aos-delay="50"
                data-aos-duration="1000"
              >
                <img
                  src="../assets/images/undraw_career_progress_ivdb.svg"
                  alt="image"
                  class=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- experience-education -->
      <section class="w3l-timeline-content-6">
        <div class="timeline-content-6 py-5">
          <div class="wrapper mx-auto py-lg-5 text-center">
            <h1
              class="heading"
              data-aos="zoom-out-up"
              data-aos-delay="50"
              data-aos-duration="1000"
            >
              KURIKULUM
            </h1>
            <br /><br />
            <p
              class="desksejarah"
              data-aos="fade-up"
              data-aos-delay="50"
              data-aos-duration="1000"
            >
              Bagi kebanyakan masyarakat kita, barangkali sebagian besar dari
              mereka pada umumnya belum mengetahui secara rinci bagaimana
              sejarah perjalanan kurikulum yang digunakan pada sistem pendidikan
              di negara kita. Pemahaman mereka pada umumnya hanya terbatas pada
              pengertian bahwa kurikulum yang digunakan di sekolah saat ini
              adalah kurikulum yang tidak pernah mengalami perubahan. Padahal
              selama ini Indonesia telah melakukan beberapa kali pergantian
              kurikulum yang digunakan. Dalam artikel ini akan digambarkan
              secara singkat kronologis pemberlakuan kurikulum pendidikan di
              Indonesia sejak kemerdekaan hingga saat ini. <br /><br />
              Berikut adalah Deskripsi singkat Sejarah perjalanan Kurikulum yang
              pernah digunakan dalam Dunia Pendidikan di Tanah Air.
            </p>

            <ul class="timeline mt-lg-5 mt-4">
              <!-- Item 1 -->
              <li>
                <div class="direction-r">
                  <div class="flag-wrapper">
                    <span class="flag">1947</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                      ><span class="time">1947</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title">Kurikulum Rencana Pelajaran</span>
                    Sejarah kurikulum pendidikan Indonesia sampai saat ini
                    dimulai dari Kurikulum Rencana Pelajaran, yakni kurikulum
                    lanjutan yang sebelumnya digunakan semasa penjajahan
                    Belanda, atau disebut juga dengan leer plan yang berarti
                    rencana pelajaran.
                  </div>
                </div>
              </li>

              <!-- Item 2 -->
              <li>
                <div class="direction-l">
                  <div class="flag-wrapper">
                    <span class="flag">1952</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                    >
                      <span class="time">1952</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title"
                      >Kurikulum Rencana Pelajaran Terurai</span
                    >
                    Kurikulum ini dapat dikatakan sebagai cikal bakal sistem
                    pendidikan Indonesia. Dalam Kurikulum Rencana Pelajaran
                    Terurai sudah terdapat rincian mata pelajaran dan
                    menggunakan silabus sebagai pokok-pokok atau isi materi
                    pelajarannya.
                  </div>
                </div>
              </li>

              <!-- Item 3 -->
              <li>
                <div class="direction-r">
                  <div class="flag-wrapper">
                    <span class="flag">1964</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                      ><span class="time">1964</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title">Kurikulum 1964</span>
                    Pada Kurikulum 1964 pemerintah menerapkan program
                    Pancawardhana sebagai pembekalan di jenjang Sekolah Dasar
                    (SD), yakni pendidikan yang meliputi pengembangan daya
                    cipta, rasa, karsa, karya, dan moral. Kemudian, untuk mata
                    pelajaran diklasifikasikan menjadi 5 kelompok bidang studi
                    yaitu, moral, kecerdasan, emosional atau artistik,
                    keterampilan, dan jasmani.
                  </div>
                </div>
              </li>

              <!-- Item 4 -->
              <li>
                <div class="direction-l">
                  <div class="flag-wrapper">
                    <span class="flag">1968</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                      ><span class="time">1968</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title">Kurikulum 1968</span>
                    Kurikulum 1968 adalah penyempurnaan dari Kurikulum Pelajaran
                    Terurai (1952) hingga Kurikulum 1964. Terjadi perubahan dari
                    program Pancawardhana menjadi pembinaan jiwa Pancasila,
                    pengetahuan dasar, dan kecakapan khusus.
                  </div>
                </div>
              </li>

              <!-- Item 5 -->
              <li>
                <div class="direction-r">
                  <div class="flag-wrapper">
                    <span class="flag">1975</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                      ><span class="time">1975</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title">Kurikulum 1975</span>
                    Pada Kurikulum 1975 sistem pendidikan memiliki orientasi
                    pada tujuan dengan harapan dapat lebih efektif dan efisien.
                    Di Kurikulum 1975 inilah mulai dikenal istilah satuan
                    pelajaran atau rencana pelajaran setiap satuan bahasan.
                    Setiap satuan pelajaran diperinci lagi menjadi petunjuk
                    umum, tujuan instruksional khusus, materi pelajaran, alat
                    pelajaran, kegiatan belajar mengajar, dan evaluasi.
                  </div>
                </div>
              </li>

              <!-- Item 6 -->
              <li>
                <div class="direction-l">
                  <div class="flag-wrapper">
                    <span class="flag">1984</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                      ><span class="time">1984</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title">Kurikulum 1984</span>
                    Kurikulum ini sering disebut juga sebagai Kurikulum 1975
                    yang disempurnakan. Melalui Kurikulum 1984 siswa mulai
                    ditempatkan sebagai subjek belajar yang diharapkan dapat
                    mengamati sesuatu, mengelompokan, mendiskusikan, hingga
                    melaporkan.
                  </div>
                </div>
              </li>

              <!-- Item 7 -->
              <li>
                <div class="direction-r">
                  <div class="flag-wrapper">
                    <span class="flag">1994 - 1999</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                      ><span class="time">1994 - 1999</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title"
                      >Kurikulum 1994 dan Suplemen Kurikulum 1999</span
                    >
                    Kurikulum ini merupakan revisi terhadap kurikulum
                    selanjutnya dan dinilai tidak memiliki dasar perbedaan yang
                    prinsipil. Pada kurikulum ini ada perubahan sistem pembagian
                    waktu pelajaran dari semester ke caturwulan. Dengan
                    pembagian waktu tersebut, diharapkan siswa dapat menerima
                    materi pembelajaran lebih banyak dalam pembagian tiga kali
                    caturwulan dalam setahun.
                  </div>
                </div>
              </li>

              <!-- Item 8 -->
              <li>
                <div class="direction-l">
                  <div class="flag-wrapper">
                    <span class="flag">2004</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                      ><span class="time">2004</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title">Kurikulum 2004</span>
                    Kurikulum 2004 atau lebih dikenal dengan KBK (Kurikulum
                    Berbasis Kompetensi) yakni, perpaduan antara pengetahuan,
                    keterampilan, nilai serta sikap yang ditunjukkan dalam
                    kebiasaan berpikir dan bertindak. Kurikulum 2004 mendapatkan
                    kritik perihal kaitan alat ukur kompetensi siswa dengan
                    ujian yang masih dengan format pilihan ganda.
                  </div>
                </div>
              </li>

              <!-- Item 9 -->
              <li>
                <div class="direction-r">
                  <div class="flag-wrapper">
                    <span class="flag">2006</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                      ><span class="time">2006</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title">Kurikulum 2006</span>
                    Berbagai kekurangan dalam KBK berakhir di awal tahun 2006
                    yang kemudian digantikan dengan KTSP (Kurikulum Tingkat
                    Satuan Pendidikan). Dari segi isi dan proses pencapaian
                    target kompetensi siswa dan teknik evaluasi pelajaran tidak
                    banyak yang berubah dengan KBK.
                  </div>
                </div>
              </li>

              <!-- Item 10 -->
              <li>
                <div class="direction-l">
                  <div class="flag-wrapper">
                    <span class="flag">2013</span>
                    <span
                      class="time-wrapper"
                      data-aos="fade-up"
                      data-aos-delay="50"
                      data-aos-duration="1250"
                      ><span class="time">2013</span></span
                    >
                  </div>
                  <div
                    class="desc"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1250"
                  >
                    <span class="title">Kurikulum 2013</span>
                    Menurut Menteri Pendidikan dan Kebudayaan, Muhammad Nuh,
                    menjelaskan bahwa kurikulum terbaru (Kurikulum 2013) akan
                    lebih menekankan pemikiran kompetensi berbasis sikap,
                    keterampilan, dan pengetahuan. Di kurikulum ini guru
                    diharapkan dapat mendorong siswa untuk melakukan observasi,
                    bertanya, bernalar, dan mengomunikasikan apa yang telah
                    siswa pahami setelah menerima materi pembelajaran.
                  </div>
                </div>
              </li>
            </ul>

            <section class="banner">
              <section class="content-slider-product">
                <!-- Swiper -->
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">JOSEPHINE WINDA</h2>
                      <p class="motivasi-text">
                        <span>"</span>Hal utama yang membedakan adalah kualitas
                        manusianya. Jika memang kualitasnya baik dan mendapat
                        pendidikan terbaik, tentunya hasil yang diperoleh akan
                        menjadi lebih maksimal<span>"</span>
                      </p>
                    </div>

                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">SIR JOHN LUBBOCK</h2>
                      <p class="motivasi-text">
                        <span>"</span>Sistem pendidikan yang bijaksana
                        setidaknya akan mengajarkan kita betapa sedikitnya yang
                        belum diketahui oleh manusia, seberapa banyak yang masih
                        harus ia pelajari<span>"</span>
                      </p>
                    </div>

                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">MARIA MONTESSORI</h2>
                      <p class="motivasi-text">
                        <span>"</span>Tugas dan pendidikan ialah mengusahakan
                        agar anak tidak mempunyai anggapan keliru bahwa kebaikan
                        sama dengan bersikap loyo dan kejahatan sama dengan
                        bersikap giat<span>"</span>
                      </p>
                    </div>

                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">ROBERT FROST</h2>
                      <p class="motivasi-text">
                        <span>"</span>Pendidikan adalah kemampuan untuk
                        mendengarkan segala sesuatu tanpa membuatmu kehilangan
                        temperamen atau rasa percaya-dirimu<span>"</span>
                      </p>
                    </div>

                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">TAN MALAKA</h2>
                      <p class="motivasi-text">
                        <span>"</span>Tujuan pendidikan itu untuk mempertajam
                        kecerdasan, memperkukuh kemauan serta memperhalus
                        perasaan<span>"</span>
                      </p>
                    </div>

                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">ALBERT EINSTEIN</h2>
                      <p class="motivasi-text">
                        <span>"</span>Pendidikan adalah apa yang tersisa setelah
                        melupakan semua yang dia pelajari di sekolah<span
                          >"</span
                        >
                      </p>
                    </div>

                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">JOHN DEWEY</h2>
                      <p class="motivasi-text">
                        <span>"</span>Pendidikan bukan persiapan untuk hidup
                        tapi pendidikan adalah hidup itu sendiri<span>"</span>
                      </p>
                    </div>

                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">MARK TWAIN</h2>
                      <p class="motivasi-text">
                        <span>"</span>Pendidikan terutama terdiri dari apa yang
                        tidak kita pelajari<span>"</span>
                      </p>
                    </div>

                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">NELSON MANDELA</h2>
                      <p class="motivasi-text">
                        <span>"</span>Pendidikan adalah senjata paling ampuh
                        untuk mengubah dunia<span>"</span>
                      </p>
                    </div>

                    <div class="swiper-slide">
                      <h2 class="motivasi-judul">ARISTOTELES</h2>
                      <p class="motivasi-text">
                        <span>"</span>Pendidikan mempunyai akar yang pahit, tapi
                        buahnya manis<span>"</span>
                      </p>
                    </div>
                  </div>
                  <!-- Add Pagination -->
                  <div class="swiper-pagination"></div>
                  <!-- Add Arrows -->
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div>
              </section>
            </section>

            <div class="imagee">
              <img
                src="../assets/images/undraw_Timeline_re_aw6g.svg"
                alt="tandatanyailustration"
                data-aos="fade-up"
                data-aos-delay="50"
                data-aos-duration="1000"
              />
            </div>
          </div>
        </div>
      </section>
      <!-- experience-education -->
    </main>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  /* eslint-disable */

  name: 'Home',
  components: {
    // HelloWorld,
  },
  mounted() {
    const swiper = new Swiper('.swiper-container', {
      loop: true,
      direction: 'vertical',
      simulateTouch: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  },
};
</script>


<style scoped>
.banner {
  width: 100%;
  height: 650px;
  display: flex;
  overflow: hidden;
  margin: 150px auto 70px auto;
}

/* Swiper */

.content-slider-product {
  border-radius: 10px;
  margin: auto;
  width: 80%;
  height: 80%;
  background: #222831;
}

.swiper-container {
  width: 90%;
  height: 100%;
  position: relative;
}
.swiper-slide {
  color: white;
  margin: auto;
  width: 80%;
  right: 10px;
  height: auto;
  text-align: left;
}
.motivasi-judul {
  font-family: Roboto, sans-serif;
  font-size: 2.5em;
  margin-top: 175px;
}
.motivasi-text {
  font-family: "Rubik", cursive;
  font-size: 1.5em;
  margin-top: 20px;
}
.motivasi-text span {
  color: #ec4357;
}

.swiper-pagination {
  width: 10px !important;
  height: 250px !important;
  left: 20px !important;
  top: 50% !important;
  transform: translateY(-50%);
}
.swiper-pagination-progressbar {
  background: #ec4357;
}
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: white;
}
.swiper-button-prev,
.swiper-button-next {
  transform: rotate(90deg);
  color: #ec4357;
}
.swiper-button-next:hover,
.swiper-button-prev:hover {
  color: white;
  transition: 0.5s;
}
.swiper-button-prev {
  top: 40%;
  right: 30px;
  left: auto;
}
.swiper-button-next {
  top: 60%;
  right: 30px;
  left: auto;
}

@media (max-width: 979px) {
  .banner {
    width: 100%;
    height: 800px;
    display: block;
    margin: 200px auto;
  }

  .content-slider-product {
    width: 100%;
    height: 44%;
  }
  .swiper-slide {
    margin: auto;
    right: 10px;
    width: 75%;
  }
  .motivasi-judul {
    margin-top: 100px;
    font-size: 2em;
  }
  .motivasi-text {
    font-size: 1.2em;
  }
}

@media (max-width: 600px) {
  .swiper-container {
    width: 100%;
  }
  .motivasi-judul {
    font-size: 1.5em;
  }
  .motivasi-text {
    font-size: 1em;
  }
}
</style>

<style scoped>
.panel {
  background: white;
  border-radius: 3px;
  text-align: left;
  padding: 5vmin;
  box-shadow: 0px 25px 42px rgba(0, 0, 0, 0.2);
  /* font-family: "Rubik", cursive; */
  z-index: 1;
}

.pendidikan-img {
  width: 100%;
  max-width: 400px;
}

#intro .intro-right {
  order: 0;
}
</style>

<style scoped>
.blob1 {
  width: 300px;
  position: absolute;
  top: 100px;
  right: -80px;
  z-index: 10;
}

.blob3 {
  width: 400px;
  position: absolute;
  top: 650px;
  left: -190px;
  z-index: 10;
}

@media (max-width: 1366px) {
  .blob1 {
    position: absolute;
    top: 100px;
    right: -160px;
  }

  .blob3 {
    position: absolute;
    top: 700px;
    left: -20%;
  }
}

@media (max-width: 670px) {
  .blob3 {
    top: 750px;
  }
}

@media (max-width: 650px) {
  .blob3 {
    top: 850px;
  }
}

@media (max-width: 540px) {
  .blob3 {
    display: none;
  }
  .blob1 {
    display: none;
  }
}
</style>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,500;1,100;1,200;1,300;1,400;1,500&display=swap");

/* Intro Page
--------------------- */

#intro {
  width: 100%;
  font-size: 16px;
  line-height: 1.7;
  font-family: Roboto, sans-serif;
  background-color: #18191c;
  /* position: relative; */
  overflow: hidden;
  min-height: 660px;
  padding-top: 120px;
}

#intro .intro-left {
  display: inline-block;
  width: 100%;
  max-width: 400px;
  padding: 3em 0;
  text-align: left;
}

#intro .intro-left h1 {
  font-size: 2.5em;
  color: #fff;
  line-height: 1.5em;
  position: relative;
  margin-bottom: 1em;
}

#intro .intro-left h1:after {
  position: absolute;
  bottom: -24px;
  left: 0;
  width: 40px;
  height: 4px;
  content: "";
  border-radius: 5px;
  background: #ec4357;
  opacity: 0.4;
}

#intro .intro-left p {
  color: #fff;
  font-size: 1.125em;
  line-height: 1.75em;
}

#intro .intro-left a.intro-cta {
  font-weight: 500;
  display: block;
  width: 100%;
  max-width: 200px;
  font-size: 1em;
  margin-top: 2em;
  padding: 1em;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  background: #ec4357;
  text-decoration: none;
}

#intro .intro-left a.intro-cta:hover {
  background-color: #222831;
  transition: 0.5s;
}

#intro .intro-right {
  position: relative;
  display: flex;
  align-items: center;

  z-index: 100;
}

#intro .intro-right img {
  width: 100%;
}

/* Section 1
--------------------- */

.section-1 {
  margin-top: -50px;
  background-color: #18191c;
  width: 100%;
  min-height: 650px;
  padding-bottom: 5em;
}

.section-1 .row .col-md-6 .gambar img {
  opacity: 0.8;
  width: 95%;
}

.section-1 .row .col-md-6 {
  display: flex;
  align-items: center;
}

.section-1 .row .col-md-6:last-child {
  position: relative;
}

.section-1 .row .col-md-6 .panel1 {
  background: white;
  border-radius: 3px;
  text-align: left;
  padding: 5vmin;
  box-shadow: 0px 25px 42px rgba(0, 0, 0, 0.2);
  /* font-family: "Rubik", cursive; */
  z-index: 1;
}

/* wew */

.section-1 .row .col-md-6 .panel1 h1 {
  font-weight: bold;
  padding: 0.4em 0;
  font-size: 1.5em;
  color: black;
}

.section-1 .row .col-md-6 .panel1 p {
  color: rgba(0, 0, 0, 0.5) !important ;
}

.section-1 .row .col-md-6 .panel1 a {
  font-weight: 500;
  display: block;
  width: 100%;
  max-width: 140px;
  margin-top: 2em;
  font-size: 0.7em;
  padding: 1em;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  background: #ec4357;
  text-decoration: none;
}

.section-1 .row .col-md-6 .panel1 a:hover {
  background-color: #222831;
  transition: 0.5s;
}

/* Section 2
--------------------- */

.section-2 {
  background-color: #18191c;
  width: 100%;
  min-height: 550px;
}

.section-2 .row .col-md-6 .gambar img {
  opacity: 0.8;
  width: 80%;
}

.section-2 .row .col-md-6:last-child {
  position: relative;
}

.section-2 .row .col-md-6 .panel2 {
  background: white;
  border-radius: 3px;
  text-align: left;
  padding: 5vmin;
  box-shadow: 0px 25px 42px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.section-2 .row .col-md-6 .panel2 h1 {
  font-weight: bold;
  padding: 0.4em 0;
  font-size: 1.5em;
  color: black;
}

.section-2 .row .col-md-6 .panel2 p {
  color: rgba(0, 0, 0, 0.5);
}

.section-2 .row .col-md-6 .panel2 a {
  font-weight: 500;
  display: block;
  width: 100%;
  max-width: 140px;
  margin-top: 2em;
  font-size: 0.7em;
  padding: 1em;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  background: #ec4357;
  text-decoration: none;
}

.section-2 .row .col-md-6 .panel2 a:hover {
  background-color: #222831;
  transition: 0.5s;
}

/* experience-education
--------------------- */

.w3l-timeline-content-6 {
  padding-bottom: 5em;
  margin-top: -75px;
  font-family: Roboto, sans-serif;
  background-color: #18191c;
}

.imagee {
  display: flex;
  justify-content: center;
  align-items: center;
}

.imagee img {
  height: 100%;
  width: 40vw;
}

.desksejarah {
  color: #fff;
  line-height: 1.75em;
}

.w3l-timeline-content-6 .timeline-content-6 .timeline {
  position: relative;
  width: 860px;
  margin: 0 auto;
  padding: 5em 0;
  list-style-type: none;
  top: 8em;
}

.w3l-timeline-content-6 .timeline-content-6 .timeline:before {
  position: absolute;
  left: 50%;
  top: 0;
  content: " ";
  display: block;
  width: 6px;
  height: 100%;
  margin-left: -3px;
  background: #ec4357;
  z-index: 5;
}

.w3l-timeline-content-6 .timeline-content-6 .timeline li {
  padding: 1em 0;
}

.w3l-timeline-content-6 .timeline-content-6 .timeline li:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.w3l-timeline-content-6 .timeline-content-6 .direction-l {
  text-align: right;
  position: relative;
  width: 400px;
  float: left;
  text-align: right;
}

.w3l-timeline-content-6 .timeline-content-6 .direction-r {
  text-align: left;
  position: relative;
  width: 400px;
  float: right;
}

.w3l-timeline-content-6 .timeline-content-6 .flag-wrapper {
  position: relative;
  display: inline-block;
  text-align: center;
}

.w3l-timeline-content-6 .timeline-content-6 .flag {
  position: relative;
  display: inline;
  background: #ec4357;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  text-align: left;
  font-size: 14px;
  color: #fff;
  line-height: 30px;
}

.w3l-timeline-content-6 .timeline-content-6 .direction-l .flag {
  box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.15);
}

.w3l-timeline-content-6 .timeline-content-6 .direction-r .flag {
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.15);
}

.w3l-timeline-content-6 .timeline-content-6 .direction-l .flag:before,
.w3l-timeline-content-6 .timeline-content-6 .direction-r .flag:before {
  position: absolute;
  top: 50%;
  right: -42px;
  content: " ";
  display: block;
  width: 24px;
  height: 24px;
  margin-top: -10px;
  background: #222831;
  border-radius: 50%;
  border: 4px solid #fff;
  z-index: 10;
}

.w3l-timeline-content-6 .timeline-content-6 .direction-r .flag:before {
  left: -42px;
}

.w3l-timeline-content-6 .timeline-content-6 .direction-l .flag:after {
  content: "";
  position: absolute;
  left: 100%;
  top: 50%;
  height: 0;
  width: 0;
  margin-top: -8px;
  border: solid transparent;
  border-left-color: #fff;
  border-width: 8px;
  pointer-events: none;
}

.w3l-timeline-content-6 .timeline-content-6 .direction-r .flag:after {
  content: "";
  position: absolute;
  right: 100%;
  top: 50%;
  height: 0;
  width: 0;
  margin-top: -8px;
  border: solid transparent;
  border-right-color: #fff;
  border-width: 8px;
  pointer-events: none;
}

.w3l-timeline-content-6 .timeline-content-6 .time-wrapper {
  display: inline;
  line-height: 1em;
  font-size: 0.66666em;
  color: #ff5959;
  vertical-align: middle;
}

.w3l-timeline-content-6 .timeline-content-6 .direction-l .time-wrapper {
  float: left;
}

.w3l-timeline-content-6 .timeline-content-6 .direction-r .time-wrapper {
  float: right;
}

.w3l-timeline-content-6 .timeline-content-6 .time {
  display: inline-block;
  padding: 6px 6px;
  background: #eef2f6;
  color: #fff;
  display: none;
}

.w3l-timeline-content-6 .timeline-content-6 .desc {
  margin: 1.4em 0.75em 0 0;
  color: #fff;
  line-height: 1.75em;
}

.w3l-timeline-content-6 .timeline-content-6 .desc span.title {
  display: block;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4em;
  color: #fff;
  margin-bottom: 10px;
}

.w3l-timeline-content-6 .timeline-content-6 .direction-r .desc {
  margin: 1.4em 0 0 0.75em;
}

.home-strip {
  display: none;
}

/* Resoponsiveness */
@media (min-width: 1199px) {
  #intro .bottom-left-gradient {
    display: none;
  }

  #intro #intro-top {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (min-width: 1100px) and (max-width: 1199px) {
  .home-strip {
    display: inline-block;
  }

  #intro .bottom-left-gradient {
    display: none;
  }

  #intro #intro-top {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .section-1 .row .col-md-6 .gambar img {
    margin-top: 220px;
  }
  .section-2 .row .col-md-6 .gambar img {
    margin-top: 190px;
  }

  .section-1 {
    padding-bottom: 200px;
  }

  .section-2 {
    margin-top: -100px;
  }
}

@media (min-width: 641px) and (max-width: 1099px) {
  #intro .intro-right {
    margin-left: 0;
    order: -1;
  }

  /* intro responsive */
  #intro-top {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    place-items: center;
  }

  #intro {
    margin-top: -80px;
    text-align: center;
    display: flex;
    height: 100%;
    padding-bottom: 100px;
    flex-direction: column;
    justify-content: space-around;
  }

  #intro .bottom-left-gradient {
    display: none;
  }

  .top-right-gradient {
    position: absolute;
    top: 5%;
    right: -3%;
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  #intro .intro-right img {
    width: 310px;
  }

  #intro h1 {
    z-index: 99;
    font-size: 24px !important;
  }

  #intro h1::after {
    margin-left: 180px;
    margin-bottom: 10px;
  }

  .intro-left {
    /* margin-left: 100px; */
  }

  #intro .intro-left {
    text-align: center !important;
  }

  #intro .intro-left .intro-cta {
    margin-top: -50px;
    z-index: 999;
    display: inline-block !important;
  }

  .section-1 {
    padding-bottom: 100px;
  }

  .section-2 {
    padding-bottom: 200px;
    margin-top: -80px;
  }

  .section-2 .row .col-md-6 .panel2 {
    margin-top: 100px;
  }

  .section-2 .row .col-md-6 .gambar img {
    margin-top: 280px;
  }
}

@media screen and (max-width: 640px) {
  .section-1 {
    padding-bottom: 55px;
  }

  #intro-top {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    place-items: center;
  }

  .intro-left {
    text-align: center;
  }
}

@media (min-width: 320px) and (max-width: 641px) {
  /* intro responsive */

  #intro .intro-right {
    margin-left: 0;
    order: -1;
  }
  #intro {
    text-align: center;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-around;
  }

  #intro .bottom-left-gradient {
    display: none;
  }

  .top-right-gradient {
    position: absolute;
    top: -5%;
    right: -5%;
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  #intro h1 {
    z-index: 99;
    font-size: 24px !important;
  }

  #intro h1::after {
    margin-left: 180px;
    margin-bottom: 10px;
  }

  .intro-left {
    text-align: center;
  }

  #intro .intro-left .intro-cta {
    margin-top: -50px;
    z-index: 999;
    display: inline-block !important;
  }

  .section-1 .row .col-md-6 .panel1 {
    margin-bottom: -70px;
    position: initial;
    width: initial;
    height: initial;
  }

  .section-2 .row .col-md-6 .panel2 {
    margin-top: 45px;
    position: initial;
    width: initial;
    height: initial;
  }

  .imagee img {
    margin-top: 130px;
    height: 100%;
    width: 70vw;
  }
}

@media (min-width: 100px) and (max-width: 410px) {
  #intro h1::after {
    display: none;
  }
}

@media (min-width: 769px) and (max-width: 823px) {
  .section-1 .row .col-md-6 .gambar img {
    padding-top: 45px;
    width: 63%;
  }
  .section-2 .row .col-md-6 .gambar img {
    padding-top: 45px;
  }
}

@media (min-width: 992px) and (max-width: 1099px) {
  .section-1 .row .col-md-6 .gambar img {
    margin-top: 160px;
    width: 70%;
  }
  .section-2 .row .col-md-6 .gambar img {
    margin-top: 200px;
    width: 70%;
  }

  .section-2 .row .col-md-6 .panel2 {
    margin-top: 50px;
  }
}

@media only screen and (max-width: 767px) {
  .section-1 .row .col-md-6 .gambar img {
    margin-top: 40px;
  }
  .section-2 .row .col-md-6 .gambar img {
    display: none;
  }

  .section-1 .row .col-md-6 .panel1 {
    margin-bottom: -70px;
    position: initial;
    width: initial;
    height: initial;
  }
  .section-2 .row .col-md-6 .panel2 {
    margin-top: 45px;
    position: initial;
    width: initial;
    height: initial;
  }

  .section-1 {
    margin-top: 0;
  }

  .section-2 {
    margin-top: -15px;
    min-height: 445px;
  }
}

@media screen and (max-width: 991px) {
  .w3l-timeline-content-6 .timeline-content-6 .timeline {
    position: relative;
    width: 680px;
  }

  .w3l-timeline-content-6 .timeline-content-6 .direction-l {
    position: relative;
    width: 310px;
    float: left;
    text-align: right;
  }

  .w3l-timeline-content-6 .timeline-content-6 .direction-r {
    position: relative;
    width: 310px;
    float: right;
  }

  .w3l-timeline-content-6 .timeline-content-6 desc span.title {
    display: block;
    font-size: 18px;
  }
}

@media screen and (max-width: 767px) {
  .w3l-timeline-content-6 {
    margin-top: -35px;
  }

  .w3l-timeline-content-6 .timeline-content-6 .timeline {
    width: 100%;
    padding: 4em 0 1em 0;
  }

  .w3l-timeline-content-6 .timeline-content-6 .timeline li {
    padding: 4em 0;
  }

  .w3l-timeline-content-6 .timeline-content-6 .direction-l,
  .w3l-timeline-content-6 .timeline-content-6 .direction-r {
    float: none;
    width: 100%;
    text-align: center;
  }

  .w3l-timeline-content-6 .timeline-content-6 .flag-wrapper {
    text-align: center;
  }

  .w3l-timeline-content-6 .timeline-content-6 .flag {
    z-index: 15;
  }

  .w3l-timeline-content-6 .timeline-content-6 .direction-l .flag:before,
  .w3l-timeline-content-6 .timeline-content-6 .direction-r .flag:before {
    position: absolute;
    top: -30px;
    left: 50%;
    content: " ";
    display: block;
    width: 16px;
    height: 16px;
    margin-left: -9px;
    background: #fff;
    border-radius: 10px;
    z-index: 10;
  }

  .w3l-timeline-content-6 .timeline-content-6 .direction-l .flag:after,
  .w3l-timeline-content-6 .timeline-content-6 .direction-r .flag:after {
    content: "";
    position: absolute;
    left: 50%;
    top: -8px;
    height: 0;
    width: 0;
    margin-left: -8px;
    border: solid transparent;
    border-bottom-color: #fff;
    border-width: 8px;
    pointer-events: none;
  }

  .w3l-timeline-content-6 .timeline-content-6 .time-wrapper {
    display: block;
    position: relative;
    margin: 4px 0 0 0;
    z-index: 14;
  }

  .w3l-timeline-content-6 .timeline-content-6 .direction-l .time-wrapper {
    float: none;
  }

  .w3l-timeline-content-6 .timeline-content-6 .direction-r .time-wrapper {
    float: none;
  }

  .w3l-timeline-content-6 .timeline-content-6 .desc {
    position: relative;
    margin: 1em 0 0 0;
    padding: 1em;
    background: #222831;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
    z-index: 15;
  }

  .w3l-timeline-content-6 .timeline-content-6 .direction-l .desc,
  .w3l-timeline-content-6 .timeline-content-6 .direction-r .desc {
    position: relative;
    margin: 1em 1em 0 1em;
    padding: 1em;
    z-index: 15;
  }

  .w3l-timeline-content-6 .timeline-content-6 .desc span.title {
    display: block;
    font-size: 20px;
  }
}
</style>
